var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.146 17h-2.9V7.652h2.9V17zM4.695 6.377a1.685 1.685 0 01-1.664-2.01 1.69 1.69 0 012.294-1.241 1.687 1.687 0 01.558 2.75 1.692 1.692 0 01-1.188.501zM17 17h-2.893v-4.55c0-1.084-.022-2.475-1.508-2.475-1.507 0-1.738 1.177-1.738 2.396V17h-2.9V7.652h2.782v1.276h.04a3.049 3.049 0 012.744-1.51C16.46 7.419 17 9.353 17 11.867V17z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default ForwardRef;